import { Button, Card, CardActions, CardContent, Chip, Collapse, GridLegacy as Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import dayjs from '../utils/dayjs-setup';
import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import { DateFormatString, DialogType, FormActions, FormatPrice, LogisticoAxiosInstance } from "../utils/constants";
import { NotAccessible } from "@mui/icons-material";
import { ActionTypes, AppContext } from "../store/AppStore";
import { ModalFormGenerador } from "../components/form/ModalForm";
import * as yup from "yup";
import { AutoCompleteInputWithLabel, CheckBoxWithLabel, InputWithLabel } from "../components/form/custom-imputs";

const HeaderContainer = styled.div`
 background:#016B61;
 color:#FFFFFF;
 height:10vh;
 padding-left:10px;
 display:flex;
 justify-content:center;
 flex-direction:column;
`;

const NotFoundContent = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
text-align:center;
width:100vw;
height:100vh;
`;


const schema = yup.object({
    conductor:yup.mixed().required(),
    vehiculo:yup.mixed().required(),
    valor:yup.number().required(),
    incluye_cargue:yup.bool().required(),
    incluye_descargue:yup.bool().required(),

   }).required();

const defaultEntity = {
    conductor:null,
    vehiculo:null,
    valor:null,
    incluye_cargue:false,
    incluye_descargue:false

}

export const SolicitudTransporte = (props)=>{

    const [solicitudData,setSolicitudData] = useState({});
    const [vehiculos,setVehiculos] = useState([]);
    const [conductores,setConductores] = useState([]);
    const [ofertas,setOfertas] = useState([]);
    const {token} = useParams(); 
    const {dispatch,store} = useContext( AppContext );
    const [isVisibleModal,setIsVisibleModal] = useState(false);
  

    useEffect(()=>{

        if ( token ){
            loadDataInit();
        }

    },[token]);



    const loadDataInit = ()=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
        });
        LogisticoAxiosInstance.post("logistico/obtener-solicitud",{},{
            headers:{
            Authorization:`Bearer ${token}`
            }
        }).then(({data})=>{
            setSolicitudData(data.value.solicitud);
            setConductores(data.value.conductores);
            setOfertas(data.value.ofertas);
            setVehiculos( data.value.vehiculos.filter( item=>item.ind_estado === 'ACTIVO').map(item=>({label:`${item.placa}-${item.nombre_tipo}`,value:item.cod}) ) );
        }).catch(err=>{

        }).finally(()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
            });
        });
    }


    if ( !token || Object.keys(solicitudData).length === 0  ){
        return <NotFoundContent>
             <Typography variant="h4" >
                    Consulta de solicitudes de vehiculos
            </Typography>
            <Typography variant="h5" >
                    El contenido que estas buscando no se encuentra disponible
            </Typography>
           <div>
           <Button  variant="contained" color="primary"  >Contactar al administrador</Button>
           </div>
        </NotFoundContent>
    }
    console.log({vehiculos});


    const configModal = {
        titleModal: "Configurar sobrecostos por producto",
        buttomsAction:[
          {
            title: "Cancelar",
            buttomProps: {
      
              type: "buttom",
              color: "secondary",
              onClick: () => setIsVisibleModal(false)
            }
          },
          {
            title: "Guardar cambios",
            color: "primary",
            buttomProps: {
              type: "submit",
              //  onClick:onSaveModData
            }
          }
      
        ],
        imputs: [
          {
            key: "conductor",
            keyValue: "conductor",
            label: "Conductor",
            component: AutoCompleteInputWithLabel,
            inputProps: {
              name: 'conductor',
              fullWidth: true,
              size:"small",
              isLoading: false,
              options: conductores|| [],
              noOptionsText: "Lista vacia",
              
            }
          },
          {
            key: "vehiculo",
            keyValue: "vehiculo",
            label: "Vehiculo",
            component: AutoCompleteInputWithLabel,
            inputProps: {
              name: 'vehiculo',
              fullWidth: true,
              isLoading: false,
              options: vehiculos || [],
              noOptionsText: "Lista vacia",
              size:"small"
            
            }
          },
          {
            key: "valor",
            keyValue: "valor",
            label: "Valor",
            responsiveSize:12,
            component: InputWithLabel,
            inputProps: {
              name: 'valor',
              fullWidth: true,
              isLoading: false,
              size:"small"
        
            }
          },
          {
            key: "incluye_cargue",
            keyValue: "incluye_cargue",
            label: "Incluye cargue?",
            component: CheckBoxWithLabel,
            inputProps: {
              name: 'incluye_cargue',
              fullWidth: true,
              isLoading: false,
              size:"small"
        
            }
          },
          {
            key: "incluye_descargue",
            keyValue: "incluye_descargue",
            label: "Incluye descargue?",
            component: CheckBoxWithLabel,
            inputProps: {
              name: 'incluye_descargue',
              fullWidth: true,
              isLoading: false,
              size:"small"
            }
          },
         
      
        ]
      };


      const onSaveData = (type,data)=>{
       
        let  payload = {
            ...data,
            cod_solicitud:solicitudData.cod
        };
        payload.conductor = payload.conductor.value;
        payload.vehiculo = payload.vehiculo.value;
        
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
        });
 
        LogisticoAxiosInstance.post("logistico/registrar-oferta",{
            ...payload,
        },{
            headers:{
            Authorization:`Bearer ${token}`
            }
        }).then(({data})=>{

            loadDataInit();
            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Propuesta de servicio",
                  message: "Su propuesta servicio ha sido enviada con exito",
                  type: DialogType.exitoso,
                  isVisible: true
                }
              });

        }).catch(err=>{

            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Error",
                  message: "Erorr al tratar de enviar los dstos",
                  type: DialogType.peligro,
                  isVisible: true
                }
              });


        }).finally(()=>{
            setIsVisibleModal(false);
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
            });
        });
        
      }

      const isDisabledAction = dayjs().isAfter(solicitudData?.fecha);

    return (
        <div>


{
    isVisibleModal &&
    <ModalFormGenerador
      isVisible={isVisibleModal}
      schemaValidator={schema}
      entityValues={{...defaultEntity}}
      {
      ...configModal
      }
      onSendForm={onSaveData}
      typeAction={FormActions.MODIFICAR}
    />
  }

            <Grid container sx={{marginTop:0}} >

                <Grid item xs={0} sm={0} md={2}  >
                   
               </Grid>
               <Grid item container xs={0} sm={0} md={8} spacing={1}  >

                    <Grid item md={12} >

                        <HeaderContainer>
                            <Typography variant="h4" >
                                Solicitud de transporte - acercate
                            </Typography>

                        </HeaderContainer>
                    </Grid>
              
                  <Grid item md={12} >
                    <Typography variant="h6" >
                            Solicitud de transporte N° {solicitudData.cod}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Vehiculo solicitado:</strong> {solicitudData.tipo_vehiculo}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Fecha de recogida:</strong> {dayjs(solicitudData.fecha).format(DateFormatString)}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Fecha de entrega:</strong> {dayjs(solicitudData.fecha_entrega_destino).format(DateFormatString)}
                        </Typography>
                  </Grid>
                  <Grid item md={6} xs={12} sm={12}  >
                     <Chip color="primary" label={`Total kilos a transportar: ${FormatPrice(solicitudData.total_kg)} KG`} ></Chip>
                  </Grid>
                  <Grid item md={6} xs={12} sm={12}  >
                     <Chip color="primary" label={`Total Canastillas a transportar: ${FormatPrice(solicitudData.total_canastillas)} Canastillas`} />
                  </Grid>
                  <Grid item md={12} marginTop={'10px'} >
                    <Typography variant="h6" >
                            Listado de rutas
                        </Typography>
                  </Grid>
                  <Grid item md={12} >

                    <Card>
                        <CardContent>
                           <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Ruta</TableCell>
                                        <TableCell>Origen</TableCell>
                                        <TableCell>Destino</TableCell>
                                        <TableCell>Total Kilos</TableCell>
                                        <TableCell>Total Canastillas</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {solicitudData.route_solicitud?.map( (item,ruta_index)=>[ <TableRow key={item.det_index} >
                                        <TableCell sx={{fontWeight:"600"}}  >{ruta_index+1}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.direccion || `${item.municipio_origen}, ${item.bodega_origen}`}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.municipio_destino}, {item.centro_op} {item.bodega}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.total_kg}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{ item.total_canastillas }</TableCell>
                                    </TableRow>,
                                <TableRow>
                                   
                                 {/*   <TableCell colSpan={5} >
                                    <Typography variant="p" fontSize='14px' fontWeight={"600"} >
                                        Listado de productos
                                    </Typography>
                                    <Table>
                                        <TableHead>
                                           <TableRow>
                                                <TableCell>Producto</TableCell>
                                                <TableCell>Total unidades</TableCell>
                                                <TableCell>Total kg</TableCell>
                                                <TableCell>Total canastillas</TableCell>
                                           </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                               item.list.map( prod=><TableRow key={prod.cod_detalle_solicitud} >
                                                <TableCell>{prod.nombre_producto}</TableCell>
                                                <TableCell>{prod.total_unidades_tranportar} {prod.un_comprada}</TableCell>
                                                <TableCell>{prod.total_ordenado_kg} Kg</TableCell>
                                                <TableCell>{prod.total_canastillas} Canastillas</TableCell>
                                           </TableRow>)
                                            }
                                        </TableBody>
                                    </Table>
                                    
                                   </TableCell> */}
                                </TableRow>
                                ] )}
                                </TableBody>
                           </Table>
                        </CardContent>
                        <CardActions sx={{display:"flex",flexDirection:"column",justifyContent:"flex-end"}} >
                            <Button  disabled={isDisabledAction} onClick={e=>setIsVisibleModal(true)} variant="contained" color="primary" >Enviar propuesta</Button>
                        </CardActions>
                    </Card>


                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="h6" >
                        Propuestas enviadas
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>N°</TableCell>
                                <TableCell>vehiculo</TableCell>
                                <TableCell>Placa</TableCell>
                                <TableCell>Conductor</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell>Cargue</TableCell>
                                <TableCell>Descarge</TableCell>
                                <TableCell>Estado</TableCell>
                            </TableRow>

                        </TableHead>
                        <TableBody>
                            {
                                ofertas?.map( item=>
                                <TableRow key={item.cod} >
                                    <TableCell>{item.cod}</TableCell>
                                    <TableCell>{item.vehiculo}</TableCell>
                                    <TableCell>{item.placa_vehiculo}</TableCell>
                                    <TableCell>{item.nombre_conductor}</TableCell>
                                    <TableCell>{FormatPrice(item.valor)}</TableCell>
                                    <TableCell>{item.incluye_cargue}</TableCell>
                                    <TableCell>{item.incluye_descargue}</TableCell>
                                   <TableCell>{item.ind_estado}</TableCell>
                                </TableRow> )
                            }
                        </TableBody>
                    </Table>
                  </Grid>

                  
                </Grid>

                   <Grid item xs={0} sm={0} md={2}  >
                   
                   </Grid>
             
            </Grid>

        </div>
    )

}